<template>
  <div class="page2_wrapper">
    <div class="container">
      <div class="main">
        <div class="breadcrumb">
          <div class="lable">当前位置:</div>
          <div class="breadcrumb_item">
            <div @click="returnPre(0)">首页</div>
            <div><span>></span>搜索结果</div>
          </div>
        </div>
        <div class="result">
          <div class="rstitle">搜索结果</div>
          <div class="split-line"></div>
          <div class="rslist">
            <div class="row" v-for="item in list" :key="item.projectid">
              <div class="name">{{item.pjnoticetitle}}<span @click="goLink(item)">查看全文</span></div>
              <div class="content">
                <div class="desc">
                  <div v-html="item.pjnoticedesc"></div>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <div class="page">
          <page @pageChanged="pageChanged" :total="total" :currentPage="query.currentPage"
                :pageSize="pageSize"></page>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import request from '@/utils/request'
  import common from '@/mixin/common'
  import Page from './common/Page'

  export default {
    name: "pjnoticeInfo",
    mixins: [common],
    components: {Page},
    data () {
      return {
        btnLoading: false,
        total: 0,
        pageSize: 10,
        query: {
          currentPage: 1,
          offset: 0
        },
        list: [],
        activeIndex: ''
      }
    },
    async created () {
      this.getList()
    },
    watch: {},
    methods: {
      async getList () {
        if (!this.$route.query.name) {
          return
        }
        this.query.limit = this.query.limit ? this.query.limit : this.pageSize
        this.query.cosid = this.cosId
        this.query.name = this.$route.query.name
        this.list = []
        let res = await request({
          url: '/web/web/getPageListForWeb',
          method: 'get',
          params: this.query
        })
        this.list = res.list
        this.loading = false
        this.total = res.count.length ? res.count[0].count : 0
      },
      pageChanged (val) {
        this.query.currentPage = val.currentPage
        this.query.limit = val.limit
        this.query.offset = val.offset
        this.getList()
      },
      goLink (val) {
        let {href} = this.$router.resolve({name: 'pjnoticeInfo', query: {pjnoticeid: val.pjnoticeid}})
        window.open(href, '_blank')
      },
      async close (val) {
        if (this.dialogType === 2) {
          await this.getPsuListByComId()
        }
        this.dialogVisible = false
        this.dialogType = 0
        this.dialogWidth = '455px'
        if (val) {
          this.goLink()
        }
      },
      returnPre (val) {
        // 返回首页
        if (val === 0) {
          this.$router.replace({path: '/'})
        }
      }
    },
    computed: {
      ...mapGetters(['parentActiveTab', 'childActiveTab', 'cosId', 'webLoginUser', 'searchcontent', 'picAddr'])
    }
  }
</script>

<style lang="scss" scoped>
  @import '../styles/variables.scss';
  /*.pjnoticeCon{*/
  /*width: 100%;*/
  /*}*/
  /*.split-line {*/
  /*width: 100%;*/
  /*margin: 0 20px;*/
  /*border-bottom: 1px solid #d1dbe5;*/
  /*// box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);*/
  /*}*/
  .page2_wrapper {
    .container {
      padding: 40px 0;
      display: flex;
      justify-content: center;
      .main {
        width: 1201px;
        background-color: $color-bg-white;
        .breadcrumb {
          padding: 25px 0 10px;
          margin: 0 20px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #FAFAFA;
          .lable {
            padding-right: 10px;
            color: $color-text-secondary-gray;
          }
          .breadcrumb_item {
            display: flex;
            justify-items: center;
            cursor: pointer;
            :last-child {
              color: $color-text-secondary-gray;
              cursor: text;
            }
            span {
              margin: 0 5px;
            }
            .breadcrumb_item_title {
              width: 380px;
              list-style: none;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }
        }
        .result {
          .rstitle {
            font-size: $fontsize-large;
            font-weight: bold;
            padding: 10px 0;
            /*width: 100%;*/
            margin: 0 20px;
            border-bottom: 1px solid #d1dbe5;
          }
          .rslist {
            padding: 0 20px;
            .row {
              padding-top: 20px;
              .name {
                font-weight: bold;
                font-size: $fontsize-large;
                span {
                  cursor: pointer;
                  padding-left: 10px;
                  font-weight: normal;
                  color: $color-orange;
                  font-size: $fontsize-medium
                }
              }
              .content {
                display: flex;
                align-items: flex-end;
                padding-bottom: 10px;
                border-bottom: 1px solid #d1dbe5;
                .desc {
                  max-height: 100px;
                  line-height: 28px;
                  padding-top: 10px;
                  list-style: none;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                }
                .c-right {
                }

              }
            }
          }
        }
      }
    }
  }
</style>